import './Login.css'
import LoginForm from "../../components/LoginForm/LoginForm";
import { useEffect, useState } from 'react';


export default function Login({updateUser}) {
  const [backgroundImage, setBackgroundImage] = useState(null);

  useEffect(() => {
    // Check if the background image is cached
    const cachedImage = localStorage.getItem('docketLoginBackgroundImage');
    if (cachedImage) {
        setBackgroundImage(cachedImage);
    } else {
        // Preload the background image and cache it
        const imageUrl = 'https://docket-assets.s3.ca-central-1.amazonaws.com/Docket+Login+Background.jpeg';
        const img = new Image();
        img.src = imageUrl;
        img.onload = () => {
            localStorage.setItem('docketLoginBackgroundImage', imageUrl);
            setBackgroundImage(imageUrl);
        };
    }
  }, []);

  return (
    <div className="Login" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className='formContainer'>
        <LoginForm updateUser={updateUser}/>
      </div>
    </ div>
  );
}
